import { CookiesCopiesType } from "./common.data";

export const GET_STARTED_kr = "지금 시작하기";
export const START_MONETIZING_kr = "수익 창출 시작";
export const BOOK_A_DEMO_kr = "데모 예약하기";
export const START_FOR_FREE_kr = "무료로 시작하기";
export const START_NOW_kr = "무료로";
export const LEARN_MORE_kr = "더 알아보기";
export const VISIT_HELP_CENTRE_kr = "도움 센터 방문";

export const cookiesCopies_kr: CookiesCopiesType = {
  description:
    "당사는 귀하의 경험을 개인화하고 당사의 웹사이트 트래픽을 분석하기 위해 쿠키를 사용합니다. 당사의 웹사이트를 계속 사용함으로써 귀하는 당사의 쿠키에 동의합니다.",
  ctas: {
    ACCEPT_COOKIES: "쿠키 수락",
    VIEW_PRIVACY_POLICY: "개인 정보보호 정책 보기",
  },
};
